import { log } from '@hotjar/insights-common/lib/log';
import { tagRecording } from '@hotjar/webapp/tracking/tools/hotjar';

/**
 * Hotjar script related tracking.
 * NOTE: Called it HotjarTracking rather than Hotjar purposely
 * just in case it could conflict with anything else.
 */
angular.module('hjApp.tracking').service('HotjarTracking', [
    '$rootScope',
    function ($rootScope) {
        /********************
         * PRIVATE VARIABLES
         ********************/
        var self = this;

        /*************************
         * PUBLIC METHODS
         *************************/

        /**
         * Set a trigger to be executed when the Angular $stateChangeSuccess occurs.
         * We use this for instances where events may happen but we only want the outcome of those events to occur
         * after the page has changed. For example, where the event would trigger a poll.
         *
         * @param {string} trigger The trigger name to fire.
         */
        this.triggerOnStateChangeSuccess = function (trigger) {
            var clearEventListener = $rootScope.$on('$stateChangeSuccess', function () {
                self.trigger(trigger);
                clearEventListener();
            });
        };

        /**
         * Track a Virtual Page View.
         *
         * @param path Virtual Page View path.
         */
        this.trackVirtualPageView = function (path) {
            log.debug('Hotjar: Tracking virtual page view ' + path);
            hj('vpv', path);
        };

        /**
         * Execute a Hotjar Javascript Trigger.
         *
         * @param trigger Name of trigger.
         */
        this.trigger = function (trigger) {
            log.debug('Hotjar: Executing Javascript Trigger ' + trigger);
            hj('trigger', trigger);
        };

        /**
         * Tag this session in Hotjar if the visitor is being recorded.
         *
         * @param tag Tag to apply.
         */
        this.tag = tagRecording;
    }
]);
